import getConfig from "next/config";
import { useRouter } from "next/router";

// INF-105 / INF-106 — señales nuevas del listado (badges por tier, etiquetas sobre la foto,
// chip Asciende con countdown) y, bajo el mismo flag, el algoritmo de ranking v2 del
// search-service (header X-Ranking: v2 — ver INF-62/INF-63).
// Encendido: env SERP_SIGNALS_V2=true (publicRuntimeConfig, se toma al boot del server
// — alcanza un reload de PM2, sin rebuild). Override por request para probar en producción
// con el flag apagado: ?serp_signals=1 (y ?serp_signals=0 fuerza apagado).

// INF-1351 — el gate de marca (`APP_THEME !== "fincaraiz"`) se sacó a propósito: la env es
// POR PROCESO, y cada país es su propia app de PM2 con su bloque `env` (FincaRaíz en
// pm2-fincaraiz-prod, y UY/PY/PE/BO en pm2-production). O sea que el país ya lo elige quien
// define la variable, y un gate acá sólo duplicaba esa decisión en build-time. Hoy sólo
// FincaRaíz la define; los 4 de InfoCasas quedan apagados por ausencia. Para prender uno:
// agregarle SERP_SIGNALS_V2: "true" a SU bloque y recargar PM2 — sin rebuild y sin tocar
// este archivo.
// ⚠️ Si alguna vez hiciera falta condicionar por país acá, NO uses
// publicRuntimeConfig.countryCode: en el build de InfoCasas vale "UY" para los 4 países
// (next.config.js lo asigna en el switch de APP_THEME, no desde COUNTRY_CODE; medido contra
// producción el 2026-09-11). Los que sí sirven son `mainDomain`, o el country_code del graph
// (ConfigStateContext / q.configs).

// Resolver puro, usable fuera de React (p. ej. en getInitialProps, para decidir el header
// de ranking). `query` = objeto de query params (router.query o el query de getInitialProps).
export const resolveSerpSignalsV2 = (query?: { serp_signals?: string | string[] }): boolean => {
	const raw = query?.serp_signals;
	const override = Array.isArray(raw) ? raw[0] : raw;
	if (override === "1") return true;
	if (override === "0") return false;

	return getConfig().publicRuntimeConfig.serpSignalsV2 === true;
};

export const useSerpSignalsV2 = (): boolean => {
	const router = useRouter();
	return resolveSerpSignalsV2(router?.query);
};
